// Import our custom CSS

import setupScrollWatch from "./scrollTools";
import {setupTracing} from "./whoami";
import setupCompatibilityHooks from "./compatibility";
import sessionManager from "@/services/SessionManager";
import bootstrap from "bootstrap";

setupTracing();
setupScrollWatch();

document.addEventListener("DOMContentLoaded", function(){
    setupCompatibilityHooks();
});

async function main() {
    if(window['__PRERENDER_INJECTED']){
        return;
    }

    let user = await sessionManager.getUserData();
    document.getElementById("dh-user-menu-placeholder").classList.add("d-none");
    if(!user){
        document.getElementById("dh-user-menu").classList.add("d-none");
        document.getElementById("dh-user-menu-create-account").classList.remove("d-none");

        let generator = document.querySelector(".nav-item-251 a");
        generator.setAttribute("href", "/best-ai-porn-generator/");
        generator.textContent = "Free AI Porn Generator";
    } else{
        document.getElementById("dh-user-menu-create-account").classList.add("d-none");
        document.getElementById("dh-user-menu").classList.remove("d-none");
        document.getElementById("dh-user-menu-logout").setAttribute("href",
            "/my-account/customer-logout?_wpnonce=" + user['logout_nonce']);

        let generator = document.querySelector(".nav-item-251 a");
        generator.setAttribute("href", "/my-collections/");
        generator.textContent = "My Collections";

        console.log(user);
    }
}

main().then();


setTimeout(() => {
    document.dispatchEvent(new Event('custom-render-trigger'));
    console.log('[Vue] Render event dispatched');
}, 2000);
